module.exports = "https://web-assets.ifttt.com/packs/media/docs/cookbook-1-ab66fc87.png";